import userSlice from './slice'

const { loginUser } = userSlice.actions

export { loginUser }

export default userSlice.reducer
